module.exports = __webpack_public_path__ + "static/Abacus HR Prozesse-06f54c9ee5a1b94381779e34f78a82dc.png";